import { sendGAEvent } from '@next/third-parties/google';

const googleEventViewSearchResult = (searchTerm: string): any => {
  return sendGAEvent('event', 'view_search_results', {
    eventName: 'view_search_results',
    params: { search_term: searchTerm },
  });
};
export default googleEventViewSearchResult;
